import { useState, useEffect } from 'react';
import { Typography, Button, IconButton, Tooltip, Grid } from '@mui/material';
import { ArrowDropDownRounded, EditRounded, InfoRounded } from '@mui/icons-material';
import { grey, red } from '@mui/material/colors';
import StockDialog from './StockDialog';
import StockOptionsDialog from './StockOptionsDialog';
import { toNumber } from 'lodash';

export default function StockField({ disableClick, editable, disabled, column, initial, onChange }) {
  const [number, setNumber] = useState(null);
  const [stockDialog, setStockDialog] = useState(false);
  const [stockOptions, setStockOptions] = useState(null);
  const [stockOptionsDialog, setStockOptionsDialog] = useState(false);

  useEffect(() => {
    if (column?.fieldType !== 'stock') return;

    const value = initial?.value;

    setNumber(value == null ? toNumber(column.stockOptions?.initial || 0) : toNumber(value));
    const options = column.stockOptions?.perRow ? initial?.options || column.stockOptions : column.stockOptions;
    setStockOptions(options);
  }, [column, initial]);

  function getStockTooltip() {
    if (stockOptions?.min == null) return '';
    return (
      <Typography>
        Min: {stockOptions.min}, Max: {stockOptions.max}
      </Typography>
    );
  }

  const background =
    number != null && stockOptions && (stockOptions.min > number || stockOptions.max < number) ? red[500] : undefined;
  return (
    <Grid container alignItems="center" justifyContent="center" wrap="nowrap">
      <Button
        style={{ textTransform: 'none', background, minWidth: 150 }}
        onClick={disableClick ? undefined : () => setStockDialog(true)}
        startIcon={editable ? <ArrowDropDownRounded /> : undefined}
        disabled={!editable || Boolean(disabled)}
        fullWidth
      >
        <Typography style={{ fontWeight: 500 }} color="textPrimary">
          {number}
        </Typography>
      </Button>

      {column.stockOptions?.perRow && (
        <>
          {editable ? (
            <>
              <IconButton style={{ width: 36, height: 36, marginLeft: 4 }} onClick={() => setStockOptionsDialog(true)}>
                <EditRounded fontSize="small" style={{ color: grey[500] }} />
              </IconButton>

              <StockOptionsDialog
                onlyMinMax
                open={stockOptionsDialog}
                onClose={() => setStockOptionsDialog(false)}
                initialOptions={stockOptions}
                onResult={(options) => {
                  setStockOptions(options);
                  onChange({ value: number, options, optionsUpdate: true });
                }}
              />
            </>
          ) : (
            <Tooltip title={getStockTooltip()} placement="top">
              <InfoRounded style={{ color: grey[400], marginLeft: 4 }} />
            </Tooltip>
          )}
        </>
      )}

      {editable && (
        <StockDialog
          open={stockDialog}
          initial={number}
          onResult={(res) => {
            if (res.value === 0) return;
            const value = number + res.value * (res.action === 'add' ? 1 : -1);
            setNumber(value);
            onChange({ value, action: res.action, delta: res.value, options: stockOptions });
          }}
          onClose={() => setStockDialog(false)}
        />
      )}
    </Grid>
  );
}
